import React from 'react';
import { st, classes } from './BadgeSelectItem.st.css';
import { ListItemSelect } from '../ListItemSelect';
import { DropdownLayoutValueOption } from '../DropdownLayout';
import {
  BadgeSelectItemBuilderProps,
  BadgeSelectItemProps,
} from './BadgeSelectItem.types';

const BadgeSelectItem = ({
  dataHook,
  skin,
  text,
  subtitle,
  ellipsis,
  selected,
  highlighted,
  disabled,
  className,
  size,
  suffix,
}: BadgeSelectItemProps) => {
  const prefix = <div className={st(classes.marker, { skin })} />;

  return (
    <ListItemSelect
      className={st(classes.root, className)}
      title={text}
      ellipsis={ellipsis}
      dataHook={dataHook}
      prefix={prefix}
      selected={selected}
      highlighted={highlighted}
      disabled={disabled}
      subtitle={subtitle}
      size={size}
      suffix={suffix}
    />
  );
};

export { BadgeSelectItem };
export const badgeSelectItemBuilder = ({
  id,
  className,
  text,
  skin,
  subtitle,
  ellipsis,
  disabled,
  dataHook,
  size,
  suffix,
}: BadgeSelectItemBuilderProps): DropdownLayoutValueOption => ({
  id,
  disabled,
  overrideOptionStyle: true,
  value: ({ selected, hovered, disabled: optionDisabled }) => (
    <BadgeSelectItem
      dataHook={dataHook}
      className={className}
      skin={skin}
      text={text}
      subtitle={subtitle}
      ellipsis={ellipsis}
      selected={selected}
      highlighted={hovered}
      disabled={optionDisabled}
      size={size}
      suffix={suffix}
    />
  ),
});
